import "../popUps/popUps.scss";
import { elevatedAccess } from "../../utils/elevatedAccess";
import { useEffect,useState } from "react";

function Info_Popup(props) {
const [infoView, setInfoView] = useState();
    function closePopup(displayType){
         const nonPopupTarget = [{ id: "", el: "" }];
    const match = nonPopupTarget.filter((f) => f.id == "popUp-display");
    const el_key = match.length > 0 ? match[0].el : "popUp-display";
    let el = document.getElementById(el_key);
    el.style.display !== "none"
      ? (el.style.display = "none")
      : (el.style.display = displayType);
  }

  const calcSectionData = [
     {
        title: 'Details',
        description: 'Calculate the cost of Digital Reach based on Office, Listing Price, and Domain Tier. Use this tool to estimate campaign spend and plan budgets with accuracy.',
        target_id: 'pg_desc',
        nonAdminVisible: false,
    },
    {
        title: 'Office',
        description: 'Office desc',
        target_id: 'office',
        nonAdminVisible: false,
    },
    {
        title: 'Suburb',
        description: 'Suburb desc',
        target_id: 'suburb',
        nonAdminVisible: false,
    },
    {
        title: 'Price',
        description: 'Price desc',
        target_id: 'price',
        nonAdminVisible: false,
    },
    {
        title: 'Tier',
        description: 'Tier Desc',
        target_id: 'tier',
        nonAdminVisible: false,
    },
    {
        title: 'New Development',
        description: 'A property that is brand-new, never lived in, or off-the-plan.',
        target_id: 'newDev',
        nonAdminVisible: true,
    }
  ];

  function previewModeToggle(){
    const btn = document.querySelector('.preview-nonAdmin-btn');
    const content = document.querySelector('.info-popup');

    if(content.classList.contains('viewOnly')){
        content.classList.add('edit-popup');
        content.classList.remove('viewOnly');
        btn.classList.remove('active-preview');
        // btn.classList.add('preview-nonAdmin-btn');
        setInfoView('editable');
    }else{
         content.classList.remove('edit-popup');
        content.classList.add('viewOnly');
        btn.classList.add('active-preview');
        // btn.classList.remove('preview-nonAdmin-btn');
        setInfoView('viewOnly');
    }
  }

  function confirmViewSetup(){
     const content = document.querySelector('.info-popup');
     const previewToggle = document.querySelector('.preview-nonAdmin-btn');
    if(!elevatedAccess.includes(
              Number(sessionStorage.getItem("user-id"))
            )){
        content.classList.add('viewOnly');
        previewToggle.style.display = 'none';
        setInfoView('viewOnly');
    }else{
        content.classList.add('edit-popup');
        setInfoView('editable');
    }
  }

  
  useEffect(() => {
    confirmViewSetup();
  }, []);
return(
    <>
    <div id="popUp-display" className="info-popup-modal">
              <div className="bg" onClick={()=>closePopup("grid")}>

              </div>
              <div className="info-popup calc-popup">
                {/*  edit-popup */}
                <h3 className="info-title">Calc Details</h3>
               <span className="material-symbols-outlined close-btn" onClick={()=>closePopup("grid")}>close</span>
               <span className="material-symbols-outlined preview-nonAdmin-btn" onClick={()=>previewModeToggle()} title={"view non admin view"}>
server_person
</span>
                 <div className="info-content calc-content">
                    <>
                    {calcSectionData.map((x, index) =>
                    <div key={index} className={x.nonAdminVisible ? "section-editable "+x.target_id+"_section": "section-editable "+x.target_id+"_section nonVisible"}>
                       
                             <input type="text" className="fieldTitle" placeholder={x.title} defaultValue={x.title} name={x.target_id+"_title"} id={x.target_id+"_title"} disabled={infoView === "viewOnly"} />
                            {/* <input type="text" className="description" placeholder={x.description} defaultValue={x.description} name={x.target_id+"_desc"} id={x.target_id+"_desc"} /> */}
                            <textarea className="description" placeholder={x.description} defaultValue={x.description} name={x.target_id+"_desc"} id={x.target_id+"_desc"}  disabled={infoView === "viewOnly"}></textarea>                        

                    
                        
                        <div className="section-actions">
                            <span className="material-symbols-outlined" title={x.nonAdminVisible ? "Hide Copy from non Admin": "Make Copy Visible to Non Admin"} onClick={()=>closePopup("grid")}>{x.nonAdminVisible ? "visibility": "visibility_off"}</span>
                            <span className="material-symbols-outlined" onClick={()=>closePopup("grid")} title={"Save Changes"}>save</span>
                        </div>
                    </div>
                    )}
                   </>
              </div>
              </div>
            
          </div>
    </>
)
}
export default Info_Popup;